import React from 'react';
import { Reveal } from './Reveal';
import { SlideFrame } from './SlideFrame';
const routes = [{
  scene: 'Scene A',
  start: 'Early control'
}, {
  scene: 'Scene B',
  start: 'Long-term control'
}, {
  scene: 'Scene C',
  start: 'Efficacy / safety / burden'
}];
const routeBeats = ['Relevant discussion', 'Relevant evidence', 'Relevant brand story'];
export function MainPerformanceSlide() {
  return <SlideFrame topBand eyebrow="The main performance" data-id="element-259" data-mp="3ma185grq2c5v">
      <header className="flex items-end justify-between gap-[5vw]" data-id="element-260" data-mp="3m75cy079e1l4">
        <h1 className="max-w-[13ch] font-display text-[clamp(49px,6.5vw,108px)] font-bold leading-[0.94] tracking-[-0.03em]" data-id="element-261" data-mp="3r94bmws20abq">
          Ask first. Present second.
        </h1>
        <p className="mb-[0.8vh] max-w-[31ch] font-display text-[clamp(19px,1.9vw,32px)] font-medium leading-[1.12] text-black/55" data-id="element-262" data-mp="3viipynh2qkp">
          Don’t give the rep a presentation. Give them a guided conversation.
        </p>
      </header>

      <div className="mt-[2.8vh] grid grid-cols-2 border-y border-black/20" data-id="element-263" data-mp="37iix7xdpz7td">
        <div className="flex items-center gap-[1vw] py-[1.4vh] pr-[2vw]" data-id="element-264" data-mp="3g10c7afqsg7a">
          <span className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.12em] text-[#D62B22]" data-id="element-265" data-mp="3b2p4p6cx6hs8">Step 01</span>
          <p className="font-sans text-[clamp(13px,1.05vw,19px)] text-black/65" data-id="element-266" data-mp="36b79kyxkvbf6">The HCP answers: “What is the biggest challenge?”</p>
        </div>
        <div className="flex items-center gap-[1vw] border-l border-black/15 py-[1.4vh] pl-[2vw]" data-id="element-267" data-mp="2wecgivk2q38a">
          <span className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.12em] text-[#D62B22]" data-id="element-268" data-mp="2scqvgmxdyin0">Step 02</span>
          <p className="font-sans text-[clamp(13px,1.05vw,19px)] text-black/65" data-id="element-269" data-mp="2ncus8pwiiv8i">Their answer determines where the conversation begins.</p>
        </div>
      </div>

      <div className="mt-[2.3vh] divide-y divide-black/15 border-y border-black/15" data-id="element-270" data-mp="lm9jbcs20n39">
        {routes.map((route, index) => <Reveal key={route.scene} delay={0.05 + index * 0.05} className="grid grid-cols-[0.45fr_1.15fr_2.4fr] items-center gap-[1.5vw] py-[1.5vh]" data-id="element-271" data-mp="gmoh8thl7ymb" data-mpi={index}>
            <span className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.12em] text-black/35" data-id="element-272" data-mp="2b1buvm6gc6jt">{route.scene}</span>
            <p className="font-display text-[clamp(18px,1.8vw,32px)] font-semibold leading-none text-[#D62B22]" data-id="element-273" data-mp="215h4g4vzl76h">{route.start}</p>
            <div className="flex items-center justify-between gap-[0.7vw]" data-id="element-274" data-mp="265d986cid2n3">
              {routeBeats.map((beat, beatIndex) => <React.Fragment key={beat} data-id="element-275" data-mp="2trtkvizwgo1h" data-mpi={beatIndex}>
                  <span className="font-sans text-[clamp(11px,0.9vw,17px)] font-medium text-black/60" data-id="element-276" data-mp="2ytiwp0uy55qm">{beat}</span>
                  {beatIndex < routeBeats.length - 1 ? <span className="text-[#D62B22]" data-id="element-277" data-mp="2jxt7ktugscho">→</span> : null}
                </React.Fragment>)}
            </div>
          </Reveal>)}
      </div>

      <div className="mt-auto flex items-end justify-between gap-[4vw] border-t-[clamp(3px,0.3vw,5px)] border-[#D62B22] pt-[1.8vh]" data-id="element-278" data-mp="18fs5dx2u7h7i">
        <p className="font-display text-[clamp(26px,2.9vw,50px)] font-semibold leading-none" data-id="element-279" data-mp="1ddjyuvj4rbdt">
          The HCP tells us <span className="text-[#D62B22]" data-id="element-280" data-mp="3mob6lyokmvo7">where to start.</span>
        </p>
        <p className="max-w-[24ch] text-right font-display text-[clamp(18px,1.8vw,31px)] font-medium leading-tight text-black/55" data-id="element-281" data-mp="3mo2pfulf1477">
          The rep becomes a guide, not a presenter.
        </p>
      </div>
    </SlideFrame>;
}